// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__2zr-x","disable":"button_disable__sD1vg","danger":"button_danger__3lG06"};